import { commaListSchema } from "@birdwatch/common";
import { z } from "zod";
import { withOperators } from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

export const usersListSearchSchema = z.object({
  search: z.string().optional(),
  filters: z
    .object({
      placeId: withOperators(commaListSchema),
      accountId: withOperators(commaListSchema),
      roles: withOperators(commaListSchema),
    })
    .optional(),
  filtersOrder: z.string().optional(),
  sort: z.string().optional(),
  userId: z.string().optional(),
  tab: z.string().optional(),
  ...maskSearchFragment,
});
